// employees/EmployeeContext.js
import React, { createContext, useContext, useState, useMemo, useEffect, useCallback } from 'react';
import {itemRender, handlePageChange, defaultPagination, pageSizeOptions} from "utils/table";
import {getAllSalaryApi} from "api/services/salary"
import { useSearchParams } from 'react-router-dom';
import useSalaryFilter from "./../hooks/filterHook"
import {  useNavigate } from "react-router-dom";
import {format} from "date-fns"
import { filterHandler } from 'utils/common';
import { useMediaQuery } from "react-responsive";

							

									  

// Create the Salary context
const salaryContext = createContext();

// Custom hook for accessing Salary context easily
export const useSalary = () => {
  return useContext(salaryContext); 
};

// SalaryProvider component to wrap around components needing access to salary data
export const SalaryProvider = ({ children }) => {
    const [searchParams, setSearchParams] = useSearchParams();

    const navigate = useNavigate()

  
  const [loading, setLoading] = useState(false);
  const [selectedPage, setSelectedPage] = useState(0);
												   
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });

  
  const [salaryData, setSalaryData] = useState([]);
  const [view, setView] = useState(isMobile? "grid":"list");
  const [showFilterDrawer, setShowFilterDrawer] = useState(false)
  const [pageSettings , setPageSettings] = useState({
    ...defaultPagination,
    page: searchParams.get("page") || 1,
    pageSize: searchParams.get("size") || 50,
    sortType: searchParams.get("sort_type") || "",
    sortBy: searchParams.get("sort_byb") || "",

})
const { handleFilterChange,
    filters,
    handleInputChange, filterLoading, setFilterLoading, handleDateChange} = useSalaryFilter(pageSettings , setPageSettings);

const getFilterParams = useCallback(()=>{
  let filter_params = filterHandler(filters)
    return filter_params
        
})

const setSalaryParams = (pageData) => {
    let filter_params = getFilterParams()
    let params = {
        size: pageData?.pageSize,
        page: pageData?.page,
        sort_by: pageData?.sortBy || "",
        sort_type: pageData?.sortType || "",
        ...filter_params
    }
    setSearchParams(params)
}



    const getSalaryList = () => {
        setLoading(true)
        setFilterLoading(true)      
        let filter_params = getFilterParams()

        if(filter_params?.employment_date_after){
            filter_params.employment_date_after = format(new Date(filter_params.employment_date_after), "yyyy-MM-dd")
        }
        if(filter_params?.employment_date_before){
            filter_params.employment_date_before = format(new Date(filter_params.employment_date_before), "yyyy-MM-dd")
        }


          
        getAllSalaryApi({
          sort_by:pageSettings?.sortBy,
          sort_type: pageSettings?.sortType,
          page_size: pageSettings?.pageSize,
          page: pageSettings?.page,
          ...filter_params
    
        }).then(response=>{
          console.log(response.data.results, "resultsss---->>>")
          if(view=="grid" && pageSettings?.page!==1){
            setSalaryData([...salaryData,...response.data.results]);

          }else{
            setSalaryData(response.data.results);

          }

          // setSalaryData(response.data.results);
          setPageSettings({
            ...pageSettings,
            total: response.data.count
          })
    
          setLoading(false)
          setFilterLoading(false)
          setShowFilterDrawer(false)
        }).catch(e=>{
          setLoading(false)
        })
    }
  useEffect(()=>{

    getSalaryList()

  },[pageSettings?.page, pageSettings?.pageSize, pageSettings?.sortBy, pageSettings?.sortType, pageSettings?.filters])

  useEffect(()=>{
    setSalaryParams(pageSettings)
  },[pageSettings])

  const handleApplyFilter = () => {
    setPageSettings({
        ...pageSettings,
        page: 1,
        filters
      })

  }


  const handleGridChange = (page, size) =>{
    setPageSettings({
      ...pageSettings,
      pageSize: size,
      page,
    })				 
			 
	
  }


  const handleChange = (pagination, filters, sorter) => {
    let pageData = handlePageChange(pagination, filters, sorter, pageSettings)
    console.log(pageData)
    setPageSettings(pageData)
  }; 
							
		
  

  const handleFilterDrawer = () => {
    console.log("JJJJJJJ")
    setShowFilterDrawer(!showFilterDrawer)
    setFilterLoading(false)
  }


  const handleSalaryDetailPage = (id, index) => {								  
    navigate(`/salary/${id}`)
    setSelectedPage(index)
  }



  // Value to be provided to context consumers
  // Memoize the context value to avoid unnecessary re-renders
  const value = useMemo(() => ({
    salaryData, setSalaryData,
    loading, setLoading,
   
    view, setView,
    pageSettings , setPageSettings,
    showFilterDrawer, setShowFilterDrawer,

    filterLoading, setFilterLoading,
    selectedPage, setSelectedPage,

    handleGridChange,
    handleChange,

    handleFilterDrawer,

    handleFilterChange,
    filters,
    handleInputChange,
    handleApplyFilter,
    handleSalaryDetailPage,
    handleDateChange
    
  }), [salaryData , view, loading, pageSettings, showFilterDrawer, filters, filterLoading, selectedPage]);

  return (
    <salaryContext.Provider value={value}>
      {children}
    </salaryContext.Provider>
  );
};